export const APP_ORIGIN = 'app://kaios-plus.kaiostech.com';

export const PATH = {
  LOADING: {
    MATCH: '/loading',
    URL: () => {
      return '/loading';
    }
  },
  APPS: {
    MATCH: '/',
    URL: () => {
      return '/';
    }
  },
  SETTING: {
    MATCH: '/setting',
    URL: () => {
      return '/setting';
    }
  },
  PAGE: {
    MATCH: '/app/:id?',
    URL: ({
      id = '',
      adId = null,
      appOrder = null,
      autoDownload = false,
      disposition = 'window',
      manifest = null,
      batchUpdating = false
    }) => {
      const params = new URLSearchParams();
      const timestamp = new Date().getTime();

      params.append('t', timestamp);
      adId && params.append('adId', adId);
      appOrder && params.append('appOrder', appOrder);
      autoDownload && params.append('autoDownload', autoDownload);
      disposition && params.append('disposition', disposition);
      manifest && params.append('manifest', encodeURIComponent(manifest));
      batchUpdating && params.append('batchUpdating', batchUpdating);

      return `/app/${id}?${params.toString()}`;
    }
  }
};

export const SUPPORTED_APP_TYPE = [
  'bookmark',
  'privileged',
  'hosted',
  'certified',
  'web'
];

// uuid of
// Payment = 'UgW01f5JflryQMM4H7SF'
// KaiOS-Store for FIH(HMD) = 'mpEy1f2paIZOdwYMzzr6'
// KaiOS-Store for All = ''daR-aFQOTlGk8DJePIQA''
export const INTERNAL_APP = [
  'UgW01f5JflryQMM4H7SF',
  'mpEy1f2paIZOdwYMzzr6',
  'daR-aFQOTlGk8DJePIQA',
  'qli0T1E695LxmxEqZer4'
];

// Google Assistant ='OSlAbgrhLArfT7grf4_N'
export const PRELOADED_APP = ['OSlAbgrhLArfT7grf4_N'];



/** WEBPACK FOOTER **
 ** ./src/constant/index.js
 **/